"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearGraphqlCache = exports.cachedGraphql = exports.dedupe = void 0;
const amplifyBootstrap_1 = require("./amplifyBootstrap");
/**
 * Short-TTL dedupe for read-only GraphQL queries.
 *
 * The dashboard cards, the lock-screen grid and every detail screen each mount
 * their own aggregation hook, and each instance fires the same
 * `getSensorAlertsBySensor` / `getSeerRating` / `getHVACFilterStatus` calls on
 * mount. On the Pi that was 18 AppSync round-trips to open the HVAC screen, 11
 * of them exact duplicates of what the dashboard fetched seconds earlier. This
 * shares one in-flight promise per (query, variables) and serves it again
 * while it is younger than `ttlMs`, so the second consumer paints from data
 * that is already here instead of waiting on the network.
 *
 * Only for queries. Mutations and subscriptions keep using `API.graphql`.
 * Failures are not cached. Callers that must see fresh data (the alert-change
 * subscription's forced refresh) call `clearGraphqlCache()` first.
 */
const DEFAULT_TTL_MS = 20_000;
const cache = new Map();
function dedupe(key, ttlMs, run) {
    const now = Date.now();
    const hit = cache.get(key);
    if (hit && now - hit.at < ttlMs)
        return hit.promise;
    const promise = run().catch((err) => {
        if (cache.get(key)?.promise === promise)
            cache.delete(key);
        throw err;
    });
    cache.set(key, { at: now, promise });
    return promise;
}
exports.dedupe = dedupe;
function cachedGraphql(op, ttlMs = DEFAULT_TTL_MS) {
    const key = op.query + ' ' + JSON.stringify(op.variables ?? {});
    return dedupe(key, ttlMs, () => amplifyBootstrap_1.API.graphql(op));
}
exports.cachedGraphql = cachedGraphql;
function clearGraphqlCache() {
    cache.clear();
}
exports.clearGraphqlCache = clearGraphqlCache;
